export default {
	baseUrl: '/power-cable-portal',
	baseUrl2: '/power-cable/',
	POWER_CABLE_PAY: '/power-cable-pay',
	POWER_CABLE_BASE: '/power-cable-base',
	POWER_CABLE_REPORT: '/power-cable-report',
	POWER_CABLE_INVOICE: '/power-cable-invoice',
	POWER_CABLE_LOGISTICS: '/power-cable-logistics', //'http://127.0.0.1:4523/m1/4832245-0-default',
	POWER_CABLE_TICKET: '/power-cable-ticket',
	POWER_CABLE_CREDIT: '/power-cable-credit',
}
